import React from "react";
import { useEventSessions } from "@seabrookstudios/pitch2table";
import { SessionListItem } from "../sessions/SessionListItem";
import { AddSessionDialog } from "../sessions/AddSessionDialog";
import { useMakeListView, useMakeListBuilder, idExtractor } from "../core/useMakeLayout";
import { NoItemsFound } from "../publisher/NoItemsFound";

const NoSessions = () => <NoItemsFound>No sessions scheduled for this event.</NoItemsFound>;

/**
 * Sessions list for an event
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ConventionId} props.conventionId
 * @param {import("@seabrookstudios/pitch2table-core").CalendarEvent} props.convention
 */
export const SessionsForEvent = ({ conventionId, convention }) => {
  const Action = () => (
    <AddSessionDialog
      seededConventionId={conventionId}
      seededDate={convention.startDate}
      seededTimeZone={convention.timezone}
    />
  );

  const useMakeList = useMakeListBuilder(
    (props) => <SessionListItem session={props.item} convention={convention} />,
    idExtractor,
    "Sessions",
    NoSessions,
    Action,
    undefined,
    undefined
  );

  const useWrappedQuery = () => useEventSessions(conventionId);

  const List = useMakeListView(useWrappedQuery, [], "event-sessions", useMakeList);

  return <List />;
};
